import {
  getURLByFileNo,
  deleteFileByFileNo,
  querySurveyBySurveyNo,
  getSurveyList,
  getCategoryList,
  getQuestionList,
  queryAnswerDetail,
  uploadFile,
  saveAnswerSurvey,
  commitSurvey,
  checkRequiredCategory
} from '@/http/jdjrSurvey'

import {
  Toast
} from 'vant'

const surveyStore = {
  namespaced: true,
  state: {
    isCustManager: false,
    surveyRole: '',
    cameraState: window.sessionStorage.getItem('cameraState') || '', // 相机是否开启
    storageState: window.sessionStorage.getItem('storageState') || '' // 存储及相册是否开启
  },
  mutations: {
    SET_ISCUSTMANAGER: (state, bool) => {
      state.isCustManager = bool
    },
    SET_SURVEYROLE: (state, data) => {
      state.surveyRole = data
    },
    SET_CAMERASTATE: (state, data) => {
      window.sessionStorage.setItem('cameraState', data)
      state.cameraState = data
    },
    SET_STORAGESTATE: (state, data) => {
      window.sessionStorage.setItem('storageState', data)
      state.storageState = data
    }
  },
  actions: {
    // 通过尽调编号查询尽调任务
    fetchSurveyBySurveyNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        querySurveyBySurveyNo(params).then(res => {
          if (!res) resolve()
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取当前登录用户的调研任务列表
    fetchSurveyList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getSurveyList(params).then(res => {
          if (res && res.resultCode === 0) {
            resolve(res.data)
          } else {
            Toast.fail(res.resultMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据问卷编号查询问卷分类
    fetchCategoryList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCategoryList(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 检查是否存在未答的必答题
    fetchCheckRequiredCategory({ commit }, params) {
      return new Promise((resolve, reject) => {
        checkRequiredCategory(params).then(res => {
          if (!res) resolve()
          if (!res.success) {
            Toast.fail(res.resMsg || '出错啦！')
          }
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据问卷编号、分类编码查询问题列表
    fetchQuestionList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getQuestionList(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据调研编号、分类编码查询答案详情（含附件信息）。
    fetchQueryAnswerDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        queryAnswerDetail(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '出错啦！')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传文件
    fetchUploadFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadFile(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res)
          } else {
            Toast.fail(res.resMsg || '上传失败')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查看已上传文件
    fetchGetURLByFileNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getURLByFileNo(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res.data)
          } else {
            Toast.fail(res.resMsg || '预览失败')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 单个删除附件，增加权限控制
    fetchDeleteFileByFileNo({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteFileByFileNo(params).then(res => {
          if (!res) return
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存答案
    fetchSaveAnswerSurvey({ commit }, params) {
      return new Promise((resolve, reject) => {
        saveAnswerSurvey(params).then(res => {
          if (!res) return
          if (res.success) {
            resolve(res)
          } else {
            Toast.fail(res.resMsg || '保存失败')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 提交任务
    fetchCommitSurvey({ commit }, params) {
      return new Promise((resolve, reject) => {
        commitSurvey(params).then(res => {
          if (!res) return
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default surveyStore



// WEBPACK FOOTER //
// ./src/store/jdjrSurveyStore.js